import React, { useState } from 'react';
import { actions } from 'react-redux-form';
import { useDispatch, connect } from 'react-redux';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import { MenuItem } from '@material-ui/core';


export interface DefaultMenuItemProps {
    value: any;
    label: string;
}
interface CustomSelectProps {
    model: any;
    value?: any;
    options: DefaultMenuItemProps[];
    label?: string;
    id: string;
}

const CustomSelect: React.FC<CustomSelectProps> = (props) => {
    return (
        <React.Fragment>
            <FormControl className='w-100'>
                <InputLabel id={props.id + 'label'}>{props.label}</InputLabel>
                <Select
                    labelId={props.id + 'label'}
                    {...props}
                >
                    {props.options.map((opt) => <MenuItem value={opt.value}>{opt.label}</MenuItem>)}
                </Select>
            </FormControl>
        </React.Fragment>
    )
}

export default connect(null)(CustomSelect);